import ProjectEditingStep from '../entity/ProjectEditingStep';

export const allWorkflowSteps: ProjectEditingStep[] = ['format', 'due', 'brief', 'option', 'preview'];

export const convertStepToOrder = (step: ProjectEditingStep, workflowSteps: ProjectEditingStep[]): number =>
  workflowSteps.indexOf(step as any);

export const getWorkflowSteps = (exceptSteps?: ProjectEditingStep[]): ProjectEditingStep[] =>
  exceptSteps && exceptSteps.length > 0
    ? allWorkflowSteps.filter((workflowStep) => !exceptSteps.includes(workflowStep as any))
    : allWorkflowSteps;
